/** Charte Aurélia : indigo, arrondis xl, Nunito pour le titre (voir header). */
export const BTN_PRIMARY =
  "inline-flex items-center justify-center rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-1 disabled:opacity-50";
export const BTN_SECONDARY =
  "inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300/80 disabled:opacity-50 dark:border-[#374151] dark:bg-[#1a2336] dark:text-slate-200 dark:hover:border-slate-600 dark:hover:bg-slate-800/60 dark:hover:text-slate-50";
export const INPUT_COFFRE =
  "w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-indigo-300 focus:ring-2 focus:ring-indigo-200/80 dark:border-[#374151] dark:bg-[#111827] dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-[#71baff]/50 dark:focus:ring-[#71baff]/25";
export const SELECT_COFFRE =
  "appearance-none rounded-xl border border-slate-200 bg-white py-2 pl-3 pr-9 text-sm font-medium text-slate-800 shadow-sm outline-none transition focus:border-indigo-300 focus:ring-2 focus:ring-indigo-200/80 disabled:cursor-not-allowed disabled:opacity-50 dark:border-[#374151] dark:bg-[#111827] dark:text-slate-100 dark:focus:border-[#71baff]/50 dark:focus:ring-[#71baff]/25";

/** Libellé champ date (Du / Au) — aligné journal d’activité. */
export const COFFRE_DATE_FIELD_LABEL =
  "text-[11px] font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400";

/** Panneaux modales — `.coffre-modal-*` passent en plein écran sous 768px (voir coffre-mobile.css). */
export const COFFRE_MODAL_BACKDROP =
  "coffre-modal-backdrop fixed inset-0 flex items-center justify-center backdrop-blur-sm";
export const COFFRE_OVERLAY_BACKDROP =
  "coffre-modal-backdrop fixed inset-0 flex items-center justify-center bg-slate-900/25 px-4 backdrop-blur-sm dark:bg-[#0b1220]/85";
export const COFFRE_MODAL_PANEL =
  "coffre-modal-panel w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-xl dark:border-[#2a3650] dark:bg-[#1a2336] dark:shadow-2xl dark:shadow-black/35";
/** Entrée en fondu — modales de confirmation / suppression. */
export const COFFRE_CONFIRM_MODAL_BACKDROP_ANIM = "coffre-confirm-modal-backdrop";
export const COFFRE_CONFIRM_MODAL_PANEL_ANIM = "coffre-confirm-modal-panel";
export const COFFRE_MODAL_KICKER =
  "mb-1 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-indigo-700 dark:text-[#71baff]";
export const COFFRE_MODAL_TITLE = "text-xl font-bold tracking-tight text-slate-900 dark:text-slate-100";
export const COFFRE_MODAL_TEXT = "text-sm leading-relaxed text-slate-600 dark:text-slate-400";
export const COFFRE_MODAL_TEXT_MUTED = "text-xs leading-relaxed text-slate-500 dark:text-slate-400";
export const COFFRE_MODAL_STRONG = "font-semibold text-slate-900 dark:text-slate-100";
export const COFFRE_MODAL_NOTE_AMBER =
  "rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-left text-[11px] leading-relaxed text-amber-950 dark:border-amber-500/35 dark:bg-amber-950/45 dark:text-amber-100";

/** Libellé par défaut de la racine Coffre (aligné sur COFFRE_DEFAULT_ROOT_LABEL côté API). */
export const COFFRE_DEFAULT_ROOT_LABEL = "Mon coffre";

export const COFFRE_VIEW_MODE_KEY = "coffre_browse_view";
export const COFFRE_SPLIT_RATIO_KEY = "coffre_split_ratio";
/** Grille liste — Nom | Date | Taille | [Partage] | Actions (+ antivirus / sélection optionnels). */
/** Pistes fixes : chaque ligne est sa propre grille — pas de `auto` sinon décalage ligne à ligne. */
const COFFRE_LIST_COL = {
  date: "4.75rem",
  size: "5.5rem",
  share: "7.5rem",
  actions: "9.25rem",
  clamav: "3.5rem",
  status: "3.5rem",
  select: "1.25rem",
};

export const COFFRE_LIST_COL_ACTIONS_W = COFFRE_LIST_COL.actions;

/** Classes largeur fixe (Tailwind — littéraux complets pour le build). */
export const COFFRE_LIST_COL_DATE_CLASS = "w-[4.75rem] min-w-[4.75rem] max-w-[4.75rem]";
export const COFFRE_LIST_COL_SIZE_CLASS = "w-[5.5rem] min-w-[5.5rem] max-w-[5.5rem]";
export const COFFRE_LIST_COL_SHARE_CLASS = "w-[7.5rem] min-w-[7.5rem] max-w-[7.5rem]";
export const COFFRE_LIST_COL_ACTIONS_CLASS = "w-[7.75rem] min-w-[7.75rem] max-w-[7.75rem] shrink-0";

export const COFFRE_LIST_COL_STATUS_CLASS = "w-[3.5rem] min-w-[3.5rem] max-w-[3.5rem]";

/** Classes grille liste — littéraux complets (Tailwind v4 ne détecte pas les template strings). */
export const COFFRE_LIST_GRID_COLS =
  "grid-cols-[3.5rem_minmax(0,1fr)_4.75rem_5.5rem_7.75rem]";
export const COFFRE_LIST_GRID_COLS_SHARE =
  "grid-cols-[3.5rem_minmax(0,1fr)_4.75rem_5.5rem_7.5rem_7.75rem]";
export const COFFRE_LIST_GRID_COLS_SELECT =
  "grid-cols-[1.25rem_3.5rem_minmax(0,1fr)_4.75rem_5.5rem_7.75rem]";
export const COFFRE_LIST_GRID_COLS_SELECT_SHARE =
  "grid-cols-[1.25rem_3.5rem_minmax(0,1fr)_4.75rem_5.5rem_7.5rem_7.75rem]";

/** Séparation verticale fine entre colonnes liste (Date, Taille, Partage, Actions). */
export const COFFRE_LIST_COL_SEP =
  "border-l border-slate-200/90 pl-3 dark:border-slate-700/65";

export function coffreListGridCols(selectionMode, shareColumn = false) {
  if (selectionMode) {
    return shareColumn ? COFFRE_LIST_GRID_COLS_SELECT_SHARE : COFFRE_LIST_GRID_COLS_SELECT;
  }
  return shareColumn ? COFFRE_LIST_GRID_COLS_SHARE : COFFRE_LIST_GRID_COLS;
}

export function readCoffreBrowseViewMode() {
  try {
    const v = localStorage.getItem(COFFRE_VIEW_MODE_KEY);
    if (v === "grid" || v === "split" || v === "columns") return v;
    return "list";
  } catch {
    return "list";
  }
}

export function readCoffreSplitRatio() {
  try {
    const n = Number(localStorage.getItem(COFFRE_SPLIT_RATIO_KEY));
    if (Number.isFinite(n) && n >= 30 && n <= 70) return n;
  } catch {
    /* ignore */
  }
  return 42;
}

export const VAULT_OPEN_STEPS = ["Authentification", "Déverrouillage", "Chargement"];
export const VAULT_CLOSE_STEPS = ["Fermeture session", "Verrouillage", "Sécurisation"];

/**
 * Zone GED ↔ Coffre (sidebar + panneau Coffre-entrant).
 * - entrant : réception depuis la GED → import sélectif dans le Coffre
 */
export const GED_VAULT_ROOT_FALLBACK = "Ma GED";

export function coffreGedVaultRoot(status) {
  if (!status?.ged_bridge_enabled) return "";
  return status?.ged_vault_root?.trim() || GED_VAULT_ROOT_FALLBACK;
}

export function coffreGedVaultEntrant(status) {
  return status?.ged_vault_entrant?.trim() || `${coffreGedVaultRoot(status)}/Coffre-entrant`;
}

export function coffreGedBreadcrumbRelative(physicalPath, status) {
  const root = coffreGedVaultRoot(status);
  if (!physicalPath || physicalPath === root) return "";
  if (physicalPath.startsWith(`${root}/`)) return physicalPath.slice(root.length + 1);
  return physicalPath;
}

export const COFFRE_TRASH_ZONE_LABEL = "Corbeille";
export const COFFRE_QUARANTINE_ZONE_LABEL = "Quarantaine";
export const COFFRE_FACTURX_LEGAL_ZONE_LABEL = "Archivage légal";
export const COFFRE_TRASH_RETENTION_DAYS_DEFAULT = 90;

export function coffreTrashRetentionDaysFromStatus(status) {
  const days = Number(status?.corbeille_retention_days);
  return Number.isFinite(days) && days > 0 ? Math.round(days) : COFFRE_TRASH_RETENTION_DAYS_DEFAULT;
}

/** Bandeau / aide zone corbeille */
export function coffreTrashRetentionHint(days = COFFRE_TRASH_RETENTION_DAYS_DEFAULT) {
  const d = coffreTrashRetentionDaysFromStatus({ corbeille_retention_days: days });
  return `Tous les dossiers et fichiers restent ${d} jours dans la corbeille Coffre, puis passent en prolongation (tuile Corbeille) jusqu’à 180 jours au total. « Vider la corbeille » bascule aussi vers cette prolongation — suppression définitive seulement après 180 jours.`;
}

/** Phrase courte pour modales et sidebar */
export function coffreTrashRetentionSentence(days = COFFRE_TRASH_RETENTION_DAYS_DEFAULT, { plural = true } = {}) {
  const d = coffreTrashRetentionDaysFromStatus({ corbeille_retention_days: days });
  if (plural) {
    return `Ils sont conservés ${d} jours en corbeille, puis supprimés définitivement. Vous pouvez les restaurer avant ce délai.`;
  }
  return `Il est conservé ${d} jours en corbeille, puis supprimé définitivement. Vous pouvez le restaurer avant ce délai.`;
}

export function coffreInferZoneForPath(path, status) {
  const root = coffreGedVaultRoot(status);
  if (root && path && (path === root || path.startsWith(`${root}/`))) return "ged";
  return "vault";
}

/** Zone de navigation — bascule auto Ma GED ↔ Mon coffre selon le chemin cible. */
export function coffreResolveNavigateZone(relPath, explicitZone, currentZone, status) {
  if (explicitZone) return explicitZone;
  const inferred = coffreInferZoneForPath(relPath, status);
  const current = currentZone || "vault";
  // Corbeille / quarantaine : rester dans la zone (sous-dossiers = chemins relatifs au stockage spécial).
  if (current === "trash" || current === "quarantine" || current === "facturx_legal") {
    return current;
  }
  if (current === "shared") {
    return inferred;
  }
  if (
    (current === "ged" && inferred === "vault") ||
    (current === "vault" && inferred === "ged")
  ) {
    return inferred;
  }
  return current === "ged" || current === "vault" ? current : inferred;
}

export const COFFRE_SHARES_NAV_LABEL = "Partages";
export const COFFRE_SHARED_RECEIVED_LABEL = "Avec moi";
export const COFFRE_SHARED_SENT_LABEL = "Par moi";
/** Fil d’Ariane zone partagée reçue */
export const COFFRE_SHARED_ZONE_LABEL = COFFRE_SHARED_RECEIVED_LABEL;

/** Préfixe chemin virtuel dossier propriétaire (accueil partagés). */
export const COFFRE_SHARED_OWNER_PATH_PREFIX = "__owner__:";

export function coffreIsSharedBrowseZone(zone) {
  return zone === "shared";
}

/** Niveau de navigation zone partagée : global | owner | content */
export function coffreSharedBrowseLevel(browseZone, sharedOwnerId, currentPath) {
  if (!coffreIsSharedBrowseZone(browseZone)) return "vault";
  if (!sharedOwnerId) return "global";
  if (!String(currentPath ?? "").trim()) return "owner";
  return "content";
}

export function coffreSharedOwnerVirtualPath(ownerId) {
  const id = Number(ownerId);
  if (!Number.isFinite(id) || id < 1) return "";
  return `${COFFRE_SHARED_OWNER_PATH_PREFIX}${id}`;
}

/** Écriture autorisée uniquement à l’intérieur d’un partage (pas à la racine ni chez le propriétaire). */
export function coffreSharedAllowWrite(browseZone, sharedOwnerId, currentPath, permission = "read") {
  if (!coffreIsSharedBrowseZone(browseZone)) return true;
  if (coffreSharedBrowseLevel(browseZone, sharedOwnerId, currentPath) !== "content") {
    return false;
  }
  return permission === "write";
}

export function coffreBrowseIsSharedReadOnly(browseZone, sharedOwnerId, sharedPermission, currentPath = "") {
  if (browseZone === "facturx_legal") return true;
  if (!coffreIsSharedBrowseZone(browseZone)) return false;
  return !coffreSharedAllowWrite(browseZone, sharedOwnerId, currentPath, sharedPermission);
}

export function coffreIsSpecialBrowseZone(zone) {
  return zone === "trash" || zone === "quarantine";
}

/** Agent desktop Windows — fichier dans suite/uploads/ (hors git). Mettre à jour à chaque release.
 *  Si le comportement change : aligner aussi CoffreAgentGuidePage.jsx (#agent). */
export const COFFRE_AGENT_VERSION = "0.4.30";
/** Fallback build — l’UI lit en priorité `coffre-agent-latest.json` au runtime. */
export const COFFRE_AGENT_SETUP_FILENAME = `Aurelia Coffre Agent_${COFFRE_AGENT_VERSION}_x64-setup.exe`;
export const COFFRE_AGENT_LATEST_JSON = "coffre-agent-latest.json";

